import { Component, ElementRef, Input, Output, ViewEncapsulation } from '@angular/core';

import { TabsComponent } from './tabs.component';

@Component({
  selector: 'tab',
  template: `
  <div *ngIf="visible" class="tab-pane fade" [ngClass]="{'in show active': active}" [id]="name" role="tabpanel">
    <ng-content></ng-content>
  </div>`,
  encapsulation: ViewEncapsulation.None
})

export class TabComponent {
  @Input() glyph: string;
  @Input() name: string;
  @Input() title: string;
  @Input() visible: boolean = true;
  @Input() counter: number;
  public active: boolean = false;
  public tabs: TabsComponent;

  constructor(private el: ElementRef, tabs: TabsComponent) {
    this.tabs = tabs;
  }

  ngOnInit() {
    this.tabs.addTab(this);
    let nativeElement: HTMLElement = this.el.nativeElement;
    if (nativeElement && nativeElement.parentElement) {
      let parentElement: HTMLElement = nativeElement.parentElement;
      while (nativeElement.firstChild) {
        parentElement.insertBefore(nativeElement.firstChild, nativeElement);
      }
      parentElement.removeChild(nativeElement);
    }
  }
}
